import HeadBlock from '$/components/global/heading';
import HeadTab from '$/components/global/headingTab';
import './index.scss';

interface IHelpCenterNavigationProps {
  children: React.ReactNode;
}

const HelpCenterNavigation: React.FC<IHelpCenterNavigationProps> = ({ children }) => {
  const baseUrl = `/help`;
  const userGuidesUrl = `${baseUrl}/user-guides`;
  const videoTutorialsUrl = `${baseUrl}/video-tutorials`;
  const excelPluginUrl = `${baseUrl}/excel-plugin`;

  return (
    <div className="help-center">
      <HeadBlock title="Help Center">
        <HeadTab title="User Guides" link={userGuidesUrl} exact={true} />
        <HeadTab title="Video Tutorials" link={videoTutorialsUrl} exact={true} />
        <HeadTab title="Excel Plugin" link={excelPluginUrl} exact={true} />
      </HeadBlock>
      <div className="content-contain">{children}</div>
    </div>
  );
};

export default HelpCenterNavigation;
